'use client';

import React, { useEffect, useState } from 'react';
import SearchAutocompleteList from '../Map/SearchAutocompleteList';

export default function Destinations() {
    const [value, setValue] = useState('');
    const [link, setLink] = useState('');
    const [allDestinations, setAllDestinations] = useState([]);
    const [filteredDestinations, setFilteredDestinations] = useState([]);

    useEffect(() => {
        fetch('/cd/feeds/destinations')
            .then((response) => response.json())
            .then((data) => {
                setAllDestinations(data);
            })
            .catch((error) => {
                alert('Could not load countries');
            });
    }, []);

    const handleInputChange = (e) => {
        const newVal = e.target.value;
        const regexObj = new RegExp(newVal, 'i');
        setValue(newVal);
        setLink('');

        if (newVal.length >= 3) {
            var newFilteredList = [];
            for (const destination of allDestinations) {
                if (destination.title.search(regexObj) !== -1) {
                    newFilteredList.push({
                        description: destination.title.replace('Travel Vaccinations for ', ''),
                        link: destination.link
                    });
                }
            }
            setFilteredDestinations(newFilteredList);
        }
    };

    const handleSelect = async (destination) => {
        setValue(destination.description);
        setLink(destination.link);
    };

    const handleButtonClick = async () => {
        if (!link) {
            return;
        }
        window.location.href = link;
    };

    return (
        <div className="destination-searchbox">
            <div className="u-relative">
                <input
                    type="text"
                    placeholder="Search destination"
                    value={value}
                    onChange={handleInputChange}
                    autoComplete="off"
                />
                <div className="destination-searchbox__icon" onClick={handleButtonClick}>
                    <svg width="22" height="18" viewBox="0 0 22 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M1 9H21M21 9L13.1429 1.5M21 9L13.1429 16.5" stroke="white" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
                    </svg>
                </div>
            </div>

            {!link && value.length >= 3 && (
                <SearchAutocompleteList
                    onSelect={handleSelect}
                    results={filteredDestinations}
                />
            )}
        </div>
    );
}
